import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
// import { OidcProvider } from "@axa-fr/react-oidc";
import { configuration } from "./services/auth/Keycloak";
import AppRouter from "./AppRouter";
import { Provider } from "react-redux";
import { persistor, store } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import "mapbox-gl/dist/mapbox-gl.css";

// import reportWebVitals from './reportWebVitals';

const Loading = (): JSX.Element => {
  return <div>Please Wait...</div>;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
    // <OidcProvider configuration={configuration()} loadingComponent={Loading}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRouter>
            <App />
          </AppRouter>
        </PersistGate>
      </Provider>
    // </OidcProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
